import lazyLoading from './lazyLoading'
import Global from '../../../services/globalservice'

export default {
  name: 'Budget',
  meta: {
    icon: 'fa-money',
    expanded: false,
    roles: Global.ALL_ROLE
  },

  children: [
    {
      name: 'Create Request',
      meta: {
        label: 'Create Request',
        roles: Global.ALL_ROLE
      },
      path: '/Budget/request',
      component: lazyLoading('Budget/CreateRequest')
    },
    {
      name: 'Budget Request',
      path: '/Budget/MyRequest/',
      meta: {
        label: 'Budget Request',
        roles: Global.ALL_ROLE,
        link: '/Budget/MyRequest/'
      },
      component: lazyLoading('Budget/MyRequest')
    },
    {
      name: 'Summary',
      meta: {
        label: 'Budget Summary',
        roles: [Global.ROLE.ADMIN]
      },
      path: '/Budget/summary',
      component: lazyLoading('Budget/Summary')
    },
    {
      name: 'All Request',
      meta: {
        label: 'All Request',
        roles: [Global.ROLE.ADMIN]
      },
      path: '/Budget/allRequest',
      component: lazyLoading('Budget/AllRequest')
    },
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/budget.js